import { getFontBase, getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import Button from 'components/Button';
import HighlightedText from 'components/HighlightedText';
import { ICONS_MAP } from 'constants/icons';
import { COMPONENTS_NAMES } from 'theme/constants';

const prefix = ['components', 'autocompleteSelect', 'lg'];

export const Icons = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  column-gap: 8px;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 8px 4px 8px 14px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;

  ${getFontBase([...prefix, 'options', 'base'])};

  background: ${getPrefixedVar(prefix, 'options', 'base', 'bg')};

  &:hover,
  &[data-is-highlighted='true'] {
    ${getFontBase([...prefix, 'options', 'hover'])};

    background: ${getPrefixedVar(prefix, 'options', 'hover', 'bg')};
  }

  &:active {
    ${getFontBase([...prefix, 'options', 'active'])};

    background: ${getPrefixedVar(prefix, 'options', 'active', 'bg')};
  }

  &[data-is-selected='true'] {
    ${getFontBase([...prefix, 'options', 'selected'])};

    background: ${getPrefixedVar(prefix, 'options', 'selected', 'bg')};
  }

  &[data-is-disabled='true'] {
    ${getFontBase([...prefix, 'options', 'disabled'])};

    background: ${getPrefixedVar(prefix, 'options', 'disabled', 'bg')};
  }
`;

/* Takes the space the icons don't need instead of a fixed 70%, and wraps at word
   boundaries — `break-all` split longer localized names mid-word
   (uk: "Інформація про депозит|и"). */
export const Text = styled(HighlightedText)`
  flex: 1 1 auto;
  min-width: 0;
  word-break: normal;
  overflow-wrap: break-word;
`;

export const StyledCheck = styled(ICONS_MAP.Check)<{ $isSingleIcon: boolean }>`
  ${({ $isSingleIcon }) =>
    $isSingleIcon &&
    css`
      margin-right: 10px;
    `}
`;

const buttonPreset = ['components', COMPONENTS_NAMES.FILTERS, 'removePresetButton'];

export const RemoveButton = styled(Button)`
  color: ${getPrefixedVar(buttonPreset, 'base', 'icon')};
  background: ${getPrefixedVar(buttonPreset, 'base', 'bg')};

  &:hover {
    color: ${getPrefixedVar(buttonPreset, 'hover', 'icon')};
    background: ${getPrefixedVar(buttonPreset, 'hover', 'bg')};
  }

  &:active {
    color: ${getPrefixedVar(buttonPreset, 'pressed', 'icon')};
    background: ${getPrefixedVar(buttonPreset, 'pressed', 'bg')};
  }
`;
